import { AnimatePresence, motion } from 'framer-motion';
var FadeIn = function (_a) {
    var children = _a.children;
    return (<AnimatePresence>
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
        {children}
      </motion.div>
    </AnimatePresence>);
};
export default FadeIn;
